import { useState } from 'react'
import { useSnapshot } from '../state/TelephonyProvider'
import { VoicemailMessagesDialog } from './VoicemailMessagesDialog'
import { IconList } from '../ui/icons'

export function VoicemailPanel() {
  const { voicemail } = useSnapshot()
  const [openMailbox, setOpenMailbox] = useState<string | null>(null)

  return (
    <div className="sb-panel">
      {voicemail.length === 0 ? (
        <div className="sb-panel-empty">No mailboxes.</div>
      ) : (
        voicemail.map((v) => (
          <div key={v.mailbox} className="card">
            <div className="row">
              <span><strong>Mailbox {v.mailbox}</strong></span>
              <span className="muted">{v.newMessages} new · {v.oldMessages} old</span>
            </div>
            <div className="btnrow">
              <button className="btn" onClick={() => setOpenMailbox(v.mailbox)}>
                <IconList size={14} stroke={1.75} /> list messages
              </button>
            </div>
          </div>
        ))
      )}
      {openMailbox ? <VoicemailMessagesDialog mailbox={openMailbox} onClose={() => setOpenMailbox(null)} /> : null}
    </div>
  )
}
